import { createI18n } from 'vue-i18n'

import esCO from '@/assets/locales/es-CO.json'
import enUS from '@/assets/locales/en-US.json'

type LocaleMessages = Record<string, unknown>

const globalMessages: Record<string, LocaleMessages> = {
  'es-CO': esCO as LocaleMessages,
  'en-US': enUS as LocaleMessages,
}

// Carga automática de mensajes por módulo: src/modules/<mod>/i18n/<locale>.json
const moduleLocaleFiles = import.meta.glob('@/modules/*/i18n/*.json', { eager: true }) as Record<
  string,
  { default: LocaleMessages }
>

const mergedMessages: Record<string, LocaleMessages> = { ...globalMessages }

for (const [path, mod] of Object.entries(moduleLocaleFiles)) {
  // path: /src/modules/<moduleName>/i18n/<locale>.json
  const match = path.match(/\/modules\/([^/]+)\/i18n\/([^/]+)\.json$/)
  if (!match) continue
  const moduleName = match[1]
  const locale = match[2]
  if (!mergedMessages[locale]) mergedMessages[locale] = {}
  ;(mergedMessages[locale] as Record<string, unknown>)[moduleName] = mod.default
}

const i18n = createI18n({
  legacy: false,
  locale: 'es-CO',
  fallbackLocale: 'en-US',
  globalInjection: true,
  messages: mergedMessages,
})

export default i18n
